import { useQuery } from "@tanstack/react-query";
import { axiosApi } from "./axios";
import { GetFedexAccountResponseDto } from "@/types/api/api-types";

//#region Get
const getAllFedexAccounts = async () => {
  return axiosApi.get<GetFedexAccountResponseDto>("v1/fedex-account").then((res) => res.data);
};

export const useGetAllFedexAccounts = () => {
  return useQuery({
    queryKey: ["fedex-account", "all"],
    queryFn: () => getAllFedexAccounts(),
    // Fetch once per app load because it almost never changes
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
//#endregion
